<div class="container">
  <app-book [listBook]="listCategory"></app-book>
</div>
